(module => {
    module.component("productsAssignment", {
        template: require('./productsAssignmentComponent.html'),
        bindings: {
            assignAction: "&",
            unassignAction: "&",
            reloadAction: "=",
            canEdit: "<",
            budgetVersion: "<"
        },
        controller: class {
            assigment: string;
            assignAction: Function;
            unassignAction: Function;
            reloadAction: Function;
            canEdit: boolean;
            budgetVersion: string;
            refreshProductSearch: Function;

            callbackScope = {
                callAssignAction: (sku: $TSFixMe) => {
                    this.assignAction({
                        sku: sku
                    }).then(() => {
                        this.refreshProductSearch();
                    });
                },
                callUnassignAction: (sku: $TSFixMe) => {
                    this.unassignAction({
                        sku: sku
                    }).then(() => {
                        this.refreshProductSearch();
                    });
                }
            };

            $onInit = () => {
                this.assigment = "showAll";
                this.reloadAction = () => {
                    this.refreshProductSearch();
                };
            };
        }
    });
})(angular.module("topline.modules"));
